import { Text } from "rizzui/typography";
import { labelClassName } from "../../projects/new/first";
import Select from "react-select";
import { useColorStyle } from "../../../hooks/useColorStyle";
import { useContext } from "react";
import { ThemeContext } from "../../../context/themeContext";
import { Controller, useForm } from "react-hook-form";
import { Button } from "rizzui/button";
import { SetStateAction } from "jotai";

export default function SelectSheet({
  submitFunction,
}: {
  submitFunction: React.Dispatch<SetStateAction<string>>;
}) {
  const { theme } = useContext(ThemeContext);
  const { campaignColorStyles } = useColorStyle(theme);
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({});

  const handleClick = handleSubmit((data) => {
    console.log(data);
    submitFunction("data-mapping");
  });
  return (
    <div className="w-[409px] flex flex-col gap-[40px]">
      <div className="w-full rounded-[8px] border-[0.5px] border-muted flex flex-col gap-[32px] px-[32px] py-[24px]">
        <div className="flex flex-col gap-[8px]">
          <Text className="font-ibmPlexSerif text-[18px] text-primary-dark font-[600]">
            Select sheet
          </Text>
          <Text className="text-[12px] font-[400] font-switzer text-[#758599]">
            Subtitle text goes here
          </Text>
        </div>

        <div className="flex flex-col gap-[24px] font-switzer">
          <Controller
            control={control}
            name="sheet"
            rules={{ required: false }}
            render={({ field }) => (
              <div className="flex flex-col gap-[8px]">
                <Text className={labelClassName}>Select spreadsheet</Text>
                <Select
                  styles={campaignColorStyles}
                  placeholder=""
                  value={field.value}
                />
              </div>
            )}
          />

          <Controller
            control={control}
            name="page"
            rules={{ required: false }}
            render={({ field }) => (
              <div className="flex flex-col gap-[8px]">
                <Text className={labelClassName}>Select page</Text>
                <Select
                  styles={campaignColorStyles}
                  placeholder=""
                  value={field.value}
                />
              </div>
            )}
          />
        </div>
      </div>
      <Button
        onClick={handleClick}
        className="!w-full !h-[35px] !bg-btn rounded-[4px]"
      >
        <Text className="font-switzer text-[12px] font-[400] text-background">
          Proceed to data mapping
        </Text>
      </Button>
    </div>
  );
}
